import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './receive-membership-benefit_types.2';

export function receiveMembershipBenefit(variable?: null, options?: GqlRequestOptions) {
  const query = 'mutation ReceiveMembershipBenefit { receiveMembershipBenefit }';
  return gql_request<types.ReceiveMembershipBenefit, null>('ReceiveMembershipBenefit', query, variable, { use_consumer: true, ...options });
}

